const { empty } = require('../../modules/element-operate');

/**
 * AmpereSelect
 * @class
 */
class AmpereSelect {

  static get elms() {
    return {
      companyClass: 'js-ampere-select-company',
      ampereClass : 'js-ampere-select-ampere',
    }
  };

  /**
   * @instance
   * @param _$el {HTMLElement}
   */
  constructor(_$el) {
    this.$company     = _$el.getElementsByClassName(AmpereSelect.elms.companyClass)[0];
    this.$ampere      = _$el.getElementsByClassName(AmpereSelect.elms.ampereClass)[0];
    this.$$companyOpt = this.$company.getElementsByTagName('option');
    this.$$ampereOpt  = this.$ampere.getElementsByTagName('option');

    this.ampereOptCloneEl = _.map(this.$$ampereOpt, (_$ampereOpt) => {
      return _$ampereOpt.cloneNode(true);
    });

    this.$company.addEventListener('change', this.onChange.bind(this), false);

    const initVal_ = this.$ampere.dataset.initVal;
    this.update(initVal_);
  }

  /**
   * @instance
   * @private
   */
  onChange() {
    this.update();
  }

  /**
   * @instance
   * @private
   * @param _initVal {string}
   */
  update(_initVal = null) {
    this.changeAmpere(this.getType(), _initVal);
  }

  /**
   * @instance
   * @private
   */
  getType() {
    const val_ = this.$company.value;

    let type = null;

    _.forEach(this.$$companyOpt, (_$el) => {
      if(val_ === _$el.text) {
        type = _$el.dataset.type;
        return false;
      }
    });

    return type;
  }

  /**
   * @instance
   * @private
   * @param _type {string}
   * @param _initVal {string}
   */
  changeAmpere(_type, _initVal) {
    empty(this.$ampere);

    const $df_ = document.createDocumentFragment();

    _.forEach(this.ampereOptCloneEl, (_$el) => {
      if(_type === _$el.dataset.type) {
        $df_.appendChild(_$el);
      }
    });

    this.$ampere.appendChild($df_);

    _.forEach(this.$$ampereOpt, (_$el) => {
      if(_$el.getAttribute('selected')) {
        _$el.selected = true;
        return false;
      }
    });

    if(_initVal) {
      this.$ampere.dispatchEvent(new CustomEvent('change', { detail: { initVal: _initVal } }));
    } else {
      this.$ampere.dispatchEvent(new CustomEvent('change'));
    }
  }

}

/**
 * class exports
 */
module.exports = AmpereSelect;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/ui/form/ampere-select.js
 **/